import React, { useState } from "react";
// import "../Assets/css/homepage.css";
import { useEffect } from "react";
import {
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { decrypt } from "../../lib/helper";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { LegalListingItemsSelector } from "../../redux/legal";
import ImagesSearchGallery from "./ImagesSearchGallery";


const ImageSearchListing = () => {
  const [sliderNumber, setSliderNumber] = useState(0);
  const [searchParams] = useSearchParams();
  const [openModal, setOpenModal] = useState(false);
  const [searchPageNumber, setSearchPageNumber] = useState(1);
  const [mainSearchResultData, setMainSearchResultData] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingImages, setIsLoadingImages] = useState(true);
  const location = useLocation();
  const { loading, imageSearchListingData } = useSelector(LegalListingItemsSelector);
  const dispatch = useDispatch();



    useEffect(()=>{
     setFinalData(imageSearchListingData?.items?.hits);
       
    },[location,imageSearchListingData?.items?.hits])


  const handleOpenModal = (index) => {
    setSliderNumber(index);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const prevSlide = () => {
    sliderNumber === 0
      ? setSliderNumber(finalData.length - 1)
      : setSliderNumber(sliderNumber - 1);
  };

  const nextSlide = () => {
    sliderNumber + 1 === finalData.length
      ? setSliderNumber(0)
      : setSliderNumber(sliderNumber + 1);
  };

  const fetchData = () => {
    if (
      isLoadingImages === false &&
      finalData.length > 0
    ) {
      searchImageResultList(finalData, searchPageNumber);
    }
  };
  return (
    <>
      {/* <SubTitleHeading
        textword={`${
          mainSearchResultData?.total === undefined
            ? "Found"
            : mainSearchResultData?.total?.value >= 10000
            ? "1,00,000" + "+"
            : mainSearchResultData?.total?.value
        } ${finalData?.length?finalData?.length:0}+ matching images`}
      /> */}
      <Box
        sx={{
          "@media only screen and (min-width: 280px) and (max-width: 749px)": {
            margin: "0px -15px",
          },
        }}
      >
        <ImagesSearchGallery
          finalData={finalData}
          fetchData={fetchData}
          hasMore={false}
          isLoadingImages={false}
          handleOpenModal={handleOpenModal}
          openModal={openModal}
          sliderNumber={sliderNumber}
          prevSlide={prevSlide}
          nextSlide={nextSlide}
          handleCloseModal={handleCloseModal}
        />
      </Box>
    </>
  );
};

export default ImageSearchListing;
